<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU Z PRZEWIJANIEM -->
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">{{  title  }}</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">
            <PartyFormFields 
                v-model="party" 
                :countries="dicts?.countries" 
                :show-gus="false" 
            />
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import PartyFormFields from './PartyFormFields.vue'

const props = defineProps({
    modelValue: { type: Object, required: true },
    dicts: { type: Object, default: () => ({ countries: [] }) },
        title: { type: String, default: '6. Współwłaściciel' }

})

const emit = defineEmits(['update:modelValue'])

const headerRef = ref(null)
const sectionCollapse = ref(false)

const party = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; user-select: none; }
</style>